<section class="terms terms-of-use" id="page">
  <app-privacy-he *ngIf="local_id === 'he'"></app-privacy-he>
  <app-privacy-en *ngIf="local_id !== 'he'"></app-privacy-en>
</section>
